module.exports = __webpack_public_path__ + "img/zh1.b77dee35.webp";